/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadPaymentInDetails(paymentDetails) {
  return await api
    .post(`/org/getpaymentin`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPaymentInReportDetails(paymentDetails) {
  return await api
    .post(`/org/paymentinreports`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPaymentInDetails(paymentDetails) {
  return await api
    .post(`/org/addpaymentin`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPaymentSettledDetails(paymentDetails) {
  return await api
    .post(`/org/getsettleinvoice`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPartyAccountDetails(paymentDetails) {
  return await api
    .post(`/org/getbankaccount`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function updatePaymentInDetails(paymentDetails) {
  return await api
    .put(`/org/editpaymentin`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deletePaymentInDetails(paymentDetails) {
  return await api
    .post(`/org/deletePaymentIn`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadPaymentInDetails,
  loadPaymentInReportDetails,
  createPaymentInDetails,
  loadRecordsMetaData,
  updatePaymentInDetails,
  deletePaymentInDetails,
  loadPaymentSettledDetails,
  loadPartyAccountDetails,
};

export default remotes;
